import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import * as Breadcrumb from '../../breadcrumbs'
import * as User from '../../user'
import * as Constants from './constants'
import * as Types from './types'

export const userCanSeeMenu = (menuItem: Types.NavItem, user: User.User) => {
  return isEmpty(menuItem.roleNames) || User.isRasaAdmin(user) ||
         menuItem.roleNames.filter((name) => user.roles.indexOf(name) >= 0).length > 0
}

const isLink = (item: Types.NavItem): boolean => isNil(item.isNoLink) || !item.isNoLink

const toBreadcrumb = (item: Types.NavItem): Breadcrumb.Breadcrumb =>
  ({title: item.label, url: (isLink(item) ? item.href : null)})

const buildBreadcrumbs = (
  menuUrl: string,
  detailName: string,
  items: Types.NavItem[],
  inputs: Breadcrumb.Breadcrumb[],
): Breadcrumb.Breadcrumb[] => {
  const matches = items.filter((item: Types.NavItem) => item.href === menuUrl)
                       .map((item: Types.NavItem) => toBreadcrumb({...item, isNoLink: isEmpty(detailName)}))
  if (isEmpty(matches)) {
    for (const item of items) {
      if (!isEmpty(item.children)) {
        if (isLink(item)) {
          // For now, suppress non-linking items from the breadcrumb list.
          inputs = inputs.concat(toBreadcrumb(item))
        }
        const bc = buildBreadcrumbs(menuUrl, detailName, item.children, inputs)
        if (!isNil(bc)) {
          return bc
        }
      }
    }
    return null
  } else {
    return inputs.concat(matches[0])
  }
}

const HOME_BREADCRUMB: Breadcrumb.Breadcrumb = {
  title: 'Home',
  url: '/',
}
export const breadcrumbs = (menuUrl: string, detailName?: string): Breadcrumb.Breadcrumbs => {
  const crumbs = buildBreadcrumbs(menuUrl, detailName, Constants.navItems, [HOME_BREADCRUMB]) || []
  if (isEmpty(detailName)) {
    return crumbs
  } else {
    return crumbs.concat({title: detailName})
  }
}



// WEBPACK FOOTER //
// ./src/components/menu/left-nav/utils.ts